export const menuItems = [
    // {
    //     id: 1,
    //     label: 'Blog Management',
    //     icon: 'bx-home-circle',
    //     subItems: [
    //         {
    //             id: 2,
    //             label: 'Sections',
    //             link: '/',
    //             parentId: 1
    //         },
    //         {
    //             id: 3,
    //             label: 'Categories',
    //             link: '/dashboard/saas',
    //             parentId: 1
    //         },
    //         {
    //             id: 4,
    //             label: 'Blogs',
    //             link: '/dashboard/crypto',
    //             parentId: 1
    //         }
    //     ]
    // }
];

